import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-632897b7")
const _hoisted_1 = { id: "trinket-grid" }
const _hoisted_2 = ["height", "width"]
const _hoisted_3 = ["cx", "cy", "fill"]
const _hoisted_4 = {
  key: 0,
  class: "no-printable",
  fill: "url(#backgroundDots)",
  height: "100%",
  width: "100%"
}
const _hoisted_5 = ["stroke"]
const _hoisted_6 = ["stroke"]
const _hoisted_7 = ["cx", "cy", "fill", "r"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TrinketGridLine = _resolveComponent("TrinketGridLine")!
  const _component_TrinketGridPoint = _resolveComponent("TrinketGridPoint")!
  const _component_TrinketGridText = _resolveComponent("TrinketGridText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "svgContainer",
      class: _normalizeClass([{ landscape: _ctx.orientation === _ctx.Orientation.LANDSCAPE }, "container"])
    }, [
      (_openBlock(), _createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleMouseClick && _ctx.handleMouseClick(...args))),
        onMousemove: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleTouchMove && _ctx.handleTouchMove(...args))),
        onTouchmove: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleTouchMove && _ctx.handleTouchMove(...args)))
      }, [
        _createElementVNode("defs", null, [
          _createElementVNode("pattern", {
            id: "backgroundDots",
            height: _ctx.gridHeight,
            width: _ctx.gridWidth,
            patternUnits: "userSpaceOnUse",
            x: "0",
            y: "0"
          }, [
            _createElementVNode("circle", {
              cx: _ctx.gridWidth / 2,
              cy: _ctx.gridHeight / 2,
              fill: _ctx.gridHelperColor,
              r: "1"
            }, null, 8, _hoisted_3)
          ], 8, _hoisted_2)
        ]),
        (_ctx.showGridHelper)
          ? (_openBlock(), _createElementBlock("rect", _hoisted_4))
          : _createCommentVNode("", true),
        (_ctx.showGridAxis)
          ? (_openBlock(), _createElementBlock("line", {
              key: 1,
              x1: "50%",
              x2: "50%",
              y1: "0",
              y2: "100%",
              class: "no-printable",
              stroke: _ctx.gridAxisColor,
              "stroke-width": "1",
              "stroke-dasharray": "10"
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true),
        (_ctx.showGridAxis)
          ? (_openBlock(), _createElementBlock("line", {
              key: 2,
              x1: "0",
              x2: "100%",
              y1: "50%",
              y2: "50%",
              class: "no-printable",
              stroke: _ctx.gridAxisColor,
              "stroke-width": "1",
              "stroke-dasharray": "10"
            }, null, 8, _hoisted_6))
          : _createCommentVNode("", true),
        _createElementVNode("circle", {
          cx: _ctx.mouseCellPosition.x + _ctx.gridPointRadius / 2,
          cy: _ctx.mouseCellPosition.y + _ctx.gridPointRadius / 2,
          fill: _ctx.gridHelperColor,
          r: _ctx.gridPointRadius,
          class: "no-printable helper-cicle"
        }, null, 8, _hoisted_7),
        (_ctx.currentLine)
          ? (_openBlock(), _createBlock(_component_TrinketGridLine, {
              key: 3,
              line: _ctx.currentLine
            }, null, 8, ["line"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.points, (point) => {
          return (_openBlock(), _createBlock(_component_TrinketGridPoint, {
            key: point.uuid,
            point: point
          }, null, 8, ["point"]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lines, (line) => {
          return (_openBlock(), _createBlock(_component_TrinketGridLine, {
            key: line.uuid,
            line: line
          }, null, 8, ["line"]))
        }), 128))
      ], 32)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.texts, (text) => {
        return (_openBlock(), _createBlock(_component_TrinketGridText, {
          key: text.uuid,
          text: text
        }, null, 8, ["text"]))
      }), 128))
    ], 2)
  ]))
}